import { inventory, crate_roll_room } from "@/api";
import { GetItemDuration, conversion } from "@/tool";
import StockAward from '@/components/stockAward';

export default {
    name: 'rollCreateItems',

    components: {
        'c-stockAward': StockAward,
    },

    filters: {
        GetItemDuration,
        conversion,
    },

    data() {
        return {
            submitting: false,
            loading: false,
            formData: null,
            selectedItems: [],
            assets_list: {
                active: false,
                current: 1,
                size: 32,
                data: {
                    list: [],
                    total: 0,
                },
            },
        };
    },

    created() {
        const savedForm = sessionStorage.getItem('rollCreateForm');
        if (!savedForm) {
            this.$router.replace({ name: 'rollCreate' });
            return;
        }
        this.formData = JSON.parse(savedForm);
        this.pageAvailableData(1);
    },

    methods: {
        parseDateTime(value) {
            if (!value) return null;
            if (value instanceof Date) return value;

            const match = String(value).match(/^(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2}):(\d{2})$/);
            if (!match) return null;

            const year = Number(match[1]);
            const month = Number(match[2]) - 1;
            const day = Number(match[3]);
            const hour = Number(match[4]);
            const minute = Number(match[5]);
            const second = Number(match[6]);
            return new Date(year, month, day, hour, minute, second);
        },

        isExpirTimeBeforeNow(value) {
            const expirTime = this.parseDateTime(value);
            if (!expirTime) return true;

            const now = new Date();
            now.setMilliseconds(0);
            return expirTime.getTime() < now.getTime();
        },

        // 单选/取消
        select(item) {
            if (item.lockType !== 0) return;
            item.active = !item.active;
            if (item.active) {
                if (!this.selectedItems.find(s => s.mSerial === item.mSerial)) {
                    this.selectedItems.push(item);
                }
            } else {
                const idx = this.selectedItems.findIndex(s => s.mSerial === item.mSerial);
                if (idx > -1) this.selectedItems.splice(idx, 1);
            }
            this.assets_list.active = this.assets_list.data.list.every(i => i.active);
        },

        // 从已选面板移除
        removeSelected(item) {
            const idx = this.selectedItems.findIndex(s => s.mSerial === item.mSerial);
            if (idx > -1) this.selectedItems.splice(idx, 1);
            const listItem = this.assets_list.data.list.find(i => i.mSerial === item.mSerial);
            if (listItem) listItem.active = false;
            this.assets_list.active = false;
        },

        // 全选/取消全选（当前页）
        selectAll(v) {
            this.assets_list.active = !v;
            this.assets_list.data.list = this.assets_list.data.list.map(item => {
                if (item.lockType !== 0 || item.isPin) return item;
                item.active = this.assets_list.active;
                if (item.active) {
                    if (!this.selectedItems.find(s => s.mSerial === item.mSerial)) {
                        this.selectedItems.push(item);
                    }
                } else {
                    const idx = this.selectedItems.findIndex(s => s.mSerial === item.mSerial);
                    if (idx > -1) this.selectedItems.splice(idx, 1);
                }
                return item;
            });
        },

        // 获取背包列表
        getinventory(obj) {
            this.loading = true;
            inventory(obj).then(res => {
                if (res.data.code === 0) {
                    const list = (res.data.data.data || []).map(item => {
                        item.active = !!this.selectedItems.find(s => s.mSerial === item.mSerial);
                        return item;
                    });
                    this.assets_list.data.list = list;
                    this.assets_list.current = res.data.data.pageNumber;
                    this.assets_list.data.total = res.data.data.totalItems;
                    this.assets_list.active = list.every(i => i.active);
                }
            }).finally(() => {
                this.loading = false;
            });
        },

        // 翻页
        pageAvailableData(v) {
            this.assets_list.current = v;
            this.getinventory({
                current: this.assets_list.current,
                size: this.assets_list.size,
            });
        },

        // 提交创建
        handleCreate() {
            const roomName = String(this.formData?.roomName || '').trim();
            const maxUser = Number(this.formData?.maxUser);

            if (!roomName) {
                return this.$toast.error('请输入房间名');
            }
            if (!this.formData?.expirTime) {
                return this.$toast.error('请选择开奖时间');
            }
            if (this.isExpirTimeBeforeNow(this.formData.expirTime)) {
                return this.$toast.error('开奖时间不能早于当前时间');
            }
            if (!maxUser || maxUser <= 0) {
                return this.$toast.error('参与人数不能为空且必须大于0');
            }
            if (this.selectedItems.length === 0) {
                return this.$toast.error('请至少选择一件物品');
            }
            this.formData.roomName = roomName;
            this.formData.maxUser = maxUser;
            this.submitting = true;
            crate_roll_room({
                ...this.formData,
                lstmSerial: this.selectedItems.map(i => i.mSerial),
            }).then(res => {
                if (res.data.code === 0) {
                    this.$toast.success('创建成功');
                    sessionStorage.removeItem('rollCreateForm');
                    this.$router.push({ name: 'rolls' });
                } else {
                    this.$toast.error(res.data.msg || '创建失败');
                }
            }).catch(() => {
                this.$toast.error('创建失败，请重试');
            }).finally(() => {
                this.submitting = false;
            });
        },
    },
};
